import {
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  CLEAR_USERS,
  GET_USER_DETAIL,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_FAIL,
  CLEAR_USER_DETAIL,
  MANAGE_USER,
  MANAGE_USER_SUCCESS,
  MANAGE_USER_FAIL,
  CLEAR_MANAGE_ERROR,
  GET_AUTHORIZATION_GROUPS,
  GET_AUTHORIZATION_GROUPS_SUCCESS,
  GET_AUTHORIZATION_GROUPS_FAIL,
} from "./actionTypes"

export const getUsers = (options, history) => ({
  type: GET_USERS,
  payload: { options, history },
})

export const getUsersSuccess = users => ({
  type: GET_USERS_SUCCESS,
  payload: users,
})

export const getUsersFail = error => ({
  type: GET_USERS_FAIL,
  payload: error,
})

export const clearUsers = () => ({
  type: CLEAR_USERS,
})

export const getUserDetail = (options, history) => ({
  type: GET_USER_DETAIL,
  payload: { options, history },
})

export const getUserDetailSuccess = user => ({
  type: GET_USER_DETAIL_SUCCESS,
  payload: user,
})

export const getUserDetailFail = error => ({
  type: GET_USER_DETAIL_FAIL,
  payload: error,
})

export const clearUserDetail = () => ({
  type: CLEAR_USER_DETAIL,
})

// Manage User Actions (create, update, activate, deactivate)
export const manageUser = (data, options, history) => ({
  type: MANAGE_USER,
  payload: { data, options, history },
})

export const manageUserSuccess = user => ({
  type: MANAGE_USER_SUCCESS,
  payload: user,
})

export const manageUserFail = error => ({
  type: MANAGE_USER_FAIL,
  payload: error,
})

export const clearManageError = () => ({
  type: CLEAR_MANAGE_ERROR,
})

// Authorization Groups Actions
export const getAuthorizationGroups = (options, history) => ({
  type: GET_AUTHORIZATION_GROUPS,
  payload: { options, history },
})

export const getAuthorizationGroupsSuccess = groups => ({
  type: GET_AUTHORIZATION_GROUPS_SUCCESS,
  payload: groups,
})

export const getAuthorizationGroupsFail = error => ({
  type: GET_AUTHORIZATION_GROUPS_FAIL,
  payload: error,
})
